/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useIntl } from '@exo/frontend-common-i18n';
import React from 'react';
import { useHistory, useLocation, Link as ReactLink } from 'react-router-dom';
import { ResetPasswordResponse } from '../../components/ForgotPasswordResponse/ForgotPasswordResponse';

export const ResetPasswordSuccessPage = () => {
  const history = useHistory();
  const location = useLocation();
  const state = location.state as LocationState;

  const intl = useIntl('features.polaris-login.polaris-login-ui.pages.ResetPasswordSuccessPage');

  const handleContinue = () => {
    history.push('/auth/enter-code');
  };
  return (
    <ResetPasswordResponse
      title={intl.msg('page.top.title', 'Forgotten Password') as string}
      text={
        intl.msg('page.body.text', '', {
          email: state?.email || 'your email address',
          link: `/auth/enter-code`,
          hresf: str => <ReactLink to={{ pathname: str }}>Enter Code page</ReactLink>
        }) as string
      }
      rightButtonLabel={intl.msg('page.bottom.button.continue', 'Continue') as string}
      rightButtonFn={handleContinue}
    />
  );
};

type LocationState = {
  email: string;
};
